<div class="tabs" [class.has-visible-overflow]="expand && visibleOverflow">
  <div class="tab" [class.tabs-bordered]="bordered">
    <input type="checkbox" [checked]="!expand" />
    <section
      class="tab-title"
      [class.title-bordered]="bordered"
      [class.title-bordered-bottom]="borderedBottom"
      [class.penalty-title]="theme === 'penalty'"
      [ngStyle]="{ height: size }"
    >
      <div
        class="is-marginless columns"
        [class.active]="isSelected"
        [class.main]="!hasExtraRow"
        [class.is-vcentered]="isVcentered"
        [ngClass]="[onChangeClasses()]"
      >
        <div class="column is-narrow p-0" [class.is-10]="fullColumn" [class.is-11]="is11Title">
          <ng-content select="[title]"></ng-content>
        </div>
        <div class="column" *ngIf="showArrow">
          <ng-content select="[arrow-extra]"></ng-content>
          <a
            (click)="toggleDetail()"
            [class.is-pulled-right]="arrowRight"
            [class.is-pulled-bottom]="arrowBottom"
            [class.w-100]="theme === 'segment'"
            class="arrow is-pulled-left px-1"
          ></a>
        </div>

        <ng-content select="[price]"></ng-content>
      </div>

      <!-- Second row -->
      <ng-content select="[extra]"></ng-content>
    </section>

    <div
      class="tab-content is-marginless"
      [ngStyle]="{ 'max-height': maxHeight }"
      [class.has-overflow]="contentOverflow"
      [class.has-visible-overflow]="visibleOverflow"
      [class.has-background-grey-lighter]="theme === 'penalty'"
    >
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>
